import { Modal, ModalBody, ModalButtonContainer } from '@/components/modal/modal';
import { Button } from '@/components/button';
import { useTranslation } from '@/contexts/i18n-context';
import { BodyLocationSelector } from '@/components/form-controls/body-location-selector';
import { TextArea } from '@/components/inputs/text-area';
import { Photo } from './photo-upload';
import styles from './photo-details-modal.module.css';
import clsx from 'clsx';
import { Img } from '@/components/img';

const translationBase = 'visit.photoUpload';
const modalTranslation = `${translationBase}.photoDetailsModal`;

interface PhotoDetailsModalProps {
  photo: Photo;
  alt: string;
  isOpen: boolean;
  onClose: () => void;
  handleSubmit: (e: React.MouseEvent<HTMLButtonElement>) => void;
  submitButtonTxt?: string;
  disableSelector?: boolean;
  isPending?: boolean;
}

export function PhotoDetailsModal({
  photo,
  alt,
  isOpen,
  onClose,
  handleSubmit,
  submitButtonTxt,
  disableSelector,
  isPending,
}: PhotoDetailsModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <h2 className="h4">{t(`${modalTranslation}.title`)}</h2>
      <div className={styles.imageContainer}>
        <Img src={photo.imageSrc} alt={alt} />
      </div>
      <ModalBody className={clsx(styles.modalBody, 'body-2')}>
        <BodyLocationSelector
          id={`bodyLocationModal_${photo.id || photo.imageSrc}`}
          label={t(`${modalTranslation}.bodyLocationTitle`)}
          name="bodyLocation"
          placeholder={t(`${translationBase}.bodyLocation.placeholder`)}
          className={styles.bodyLocationContainer}
          disabled={disableSelector}
        />
        <TextArea
          id={`textAreaModal_${photo.id || photo.imageSrc}`}
          label={t(`${modalTranslation}.descriptionTitle`)}
          name="description"
          placeholder={t(`${translationBase}.update.placeholder`)}
          rows={3}
          maxLength={250}
        />
      </ModalBody>
      <ModalButtonContainer>
        <Button variant="outlined" disabled={isPending} onClick={onClose}>
          {t(`${modalTranslation}.cancelButton`)}
        </Button>
        <Button onClick={(e) => handleSubmit(e)} loading={isPending}>
          {submitButtonTxt ?? t(`${modalTranslation}.saveButton`)}
        </Button>
      </ModalButtonContainer>
    </Modal>
  );
}
